import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import Store from "~/common/Store";
import { getHashedCustomerEmail } from "~/userAnalytics";
import { setAnalyticsBrowser } from "./loadAnalyticsBrowser";
import isMobile from "../../common/helpers/isMobile";
import { sendCustomerIoMobilePageViewEvent } from "./CustomerIoEvents";
import { env } from "~/common/Environment";

const writeKey = env.isProd ? "b274e5d7e1c8ea9f94cf" : "a2add68a2309306bfc05";
const siteId = env.isProd ? "1760163a8fa7753d6c07" : "dc7a833c13bd3ae01b38";

export const analytics = AnalyticsBrowser.load(
  { writeKey },
  // Optional: Add in-app messaging support
  {
    integrations: {
      "Customer.io In-App Plugin": {
        siteId,
      },
    },
  },
);

const loadCustomerIoAnalytics = async () => {
  setAnalyticsBrowser(analytics);
  const cioUser = await analytics.user();
  const { user } = Store.getState();
  const cioUserId = cioUser.id();

  if (user.emailAddress && !cioUserId) {
    const hashedEmail = getHashedCustomerEmail(user.emailAddress);
    analytics.identify(hashedEmail, {
      email: user.emailAddress,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  } else if (!user.emailAddress && cioUserId) {
    analytics.reset();
  }
  analytics.page();
  if (isMobile()) {
    sendCustomerIoMobilePageViewEvent();
  }
};

export default loadCustomerIoAnalytics;
